import { PostgradTrial, RawPostgradTrial } from '@/models/postgradTrial/PostgradTrialModel';
import { ENDPOINTS } from '@/settings/endpoints';
import axios from 'axios';
import SentryClient from '../sentry';

interface GetTrialResponseType {
  data: RawPostgradTrial;
}

export default class TrialRequestService {
  static async getTrial(
    descomplicaToken: string,
    descomplicaCourseId: string,
  ): Promise<PostgradTrial | null> {
    try {
      const response = await axios.get<GetTrialResponseType>('', {
        baseURL: ENDPOINTS.pegasusMustang.POSTGRAD_TRIAL as string,
        params: {
          descomplicaCourseId,
        },
        headers: {
          Authorization: `Bearer ${descomplicaToken}`,
        },
      });

      const rawPostgradTrial = response.data.data;

      return {
        ...rawPostgradTrial,
        startDate: new Date(rawPostgradTrial.startDate),
        expirationDate: new Date(rawPostgradTrial.expirationDate),
      };
    } catch (err) {
      SentryClient.captureError(err);
    }

    return null;
  }
}
